import { Grid } from '@mui/material';
import './welcomed.styles.scss';
import Button from '../../../components/button/button.component';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../contexts/cancellation.context';
import { freshDeskReport } from '../../../utils/generaFunctions';
import { Link, useNavigate } from 'react-router-dom';

const Welcomed = () => {
    const {userInfo, cancelInfo, setLoading, changeCancelInfo} = useContext(CancelContext);
    const navigate = useNavigate();
    return (
        <Grid container className='welcomed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>don't miss 4 more<br/>postpartum themes</h1>
                </Grid>
                <div id="welcomed_img"/>
                <Grid item className="small-header">
                    sneak peek at what you could miss in future boxes:
                </Grid>
                <Grid item className='body-book' >
                <ul style={{marginBottom:"0", marginTop:"0"}}>
                    <li className='check'><span className='body-demi'>Capture Precious Milestones: </span>Milestone Baby Blanket, Keepsake Memory Box</li>
                    <li className='check'><span className='body-demi'>Stylish Matching Sets: </span>Mom and Baby T-Shirts, Mama Tumbler, Kid Sippy Cup</li>
                    <li className='check'><span className='body-demi'>Support Baby's Development: </span>Interactive Growth Chart, Milestone Tracking Cards</li>
                </ul>
                </Grid>
                <Grid item id='button-container'>
                    <Link className={`button-link`} onClick={()=>{
                        changeCancelInfo({welcomed: true});
                        setLoading(true);
                        freshDeskReport(userInfo.email, userInfo.name, "Prevented From: Already welcomed", "SysT1.0: Prevented","SysT1.0: Prevented", "SysT1.0: Already Welcomed").then((data)=>{
                            navigate("../keep"+window.location.search);
                        })
                    }}><Button text="keep subscription"/></Link>
                    <Link className={`button-link`} to={"../offer"+window.location.search}><Button className="btn-reverse" text="continue to cancel"/></Link>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Welcomed;